import React, {useEffect} from "react";
import {connect} from "react-redux";
import Config from "../../../config";

export default (WrappedComponent) => {

  const WithPingPilotCheck = (props) => {

    const {language, fabricatorData, jobId, encodedUserId, dialCode, phoneNumber, email} = props;

    useEffect(() => {
      if (!fabricatorData.usePingWidget || Config.isDevMode()) {
        return
      }
      let scriptAdded = document.getElementById("pingpilot");
      if (!scriptAdded) {
        scriptAdded = document.createElement('script');
        scriptAdded.setAttribute('type','text/javascript');
        scriptAdded.setAttribute('id','pingpilot');
        scriptAdded.setAttribute('src','https://widget.pingpilot.com');
        scriptAdded.setAttribute('async','');
        // scriptAdded.setAttribute('data-signal','quotecountertopsdemo');
        scriptAdded.setAttribute('data-signal', fabricatorData.dataSignal || "");
        scriptAdded.setAttribute('data-fabricatorid', document.kvConfig.userId || "");
        // dynamic fields
        scriptAdded.setAttribute('data-language', language);
        scriptAdded.setAttribute('data-jobid', document.kvConfig.jobId || jobId || "");
        scriptAdded.setAttribute('data-clientid', encodedUserId || "");
        scriptAdded.setAttribute('data-clientemail', encodedUserId || "");
        scriptAdded.setAttribute('data-clientdialсode', encodedUserId || "");
        scriptAdded.setAttribute('data-clientphone', encodedUserId || "");
        document.body.appendChild(scriptAdded);
      } else {
        scriptAdded.setAttribute('data-language', language);
        scriptAdded.setAttribute('data-jobid', document.kvConfig.jobId || jobId || "");
        scriptAdded.setAttribute('data-clientid', encodedUserId || "");
        scriptAdded.setAttribute('data-clientemail', email || "");
        scriptAdded.setAttribute('data-clientdialсode', dialCode || "");
        scriptAdded.setAttribute('data-clientphone', phoneNumber || "");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language, fabricatorData, jobId, encodedUserId]);

    let scriptAdded = document.getElementById("pingpilot");
    if (!scriptAdded) {
      return null
    }

    const pingButton = document.querySelector(".pingpilot-button");
    if (!pingButton) {
      return null
    }

    return (
      <WrappedComponent {...props} pingButton={pingButton}/>
    )

  };

  const mapStateToProps = (store) => {
    const {language, jobId} = store.serverState;
    const {encodedUserId, userInfo} = store.userState;
    const fabricatorData = store.fabricatorState;

    return {
      jobId,
      language,
      fabricatorData,
      encodedUserId,
      dialCode: userInfo.country ? userInfo.country.dialCode : "",
      phoneNumber: userInfo.phoneNumber || userInfo.phone,
      email: userInfo.email,
    };
  };

  return connect(mapStateToProps)(WithPingPilotCheck)
}
